import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { config } from "../../config/config";
import { OrderStatus, transactionStatus } from '../../common/constant';
import orderService from '../../service/OrderService';
import commissionService from "../../service/CommissionService";

export const ViewOrderDetail = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [orderDetails, serOrderDetails] = useState({});
  const [commission, setCommission] = useState(null);

  useEffect(() => {
    fetchCommission()
    fetchOrderDetails()
  }, [])

  const fetchOrderDetails = async () => {
    const response = await orderService.getDetail(id);
    if (response.status == 200) {
      serOrderDetails(response.data.data.order)
    }
  }

  const fetchCommission = async () => {
    const response = await commissionService.getOrderCommission(id)
    if (response.status == 200) {
      setCommission(response.data.data.commission)
    }
  }


  const userDetail = (type, user) => (
      <Col md={4}>
        <div className="setting-box">
          <div className="under-setting main">
            <p>{ type }</p>

            <div className="under-bx">
              <div>Name</div>
              <div>
                <a href={`/users/${user._id}`}>{ user.fullName }</a>
              </div>
            </div>

            <div className="under-bx">
              <div>Email</div>
              <div>{ user.email }</div>
            </div>

            <div className="under-bx">
              <div>Phone</div>
              <div>{ user.phone }</div>
            </div>
          </div>
        </div>
      </Col>
  )

  return (
    <>
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex referral-details">
                    <h2 className="user-info-heading"><i className="fa fa-angle-left" aria-hidden="true" onClick={() => navigate('/orders')}></i>Order Details</h2>
                  </div>
                </div>
              </Col>
              <Row>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Name</h6>
                    <p>{orderDetails?.product?.name}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Description</h6>
                    <p>{orderDetails?.description || 'NA'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Bid Duration Days </h6>
                    <p>{orderDetails?.bidDurationDays}</p>
                  </div>
                </Col>

                {/* <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Bid Extended Count </h6>
                    <p>{orderDetails?.extendCount}</p>
                  </div>
                </Col> */}

                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Status </h6>
                    <p>{OrderStatus[orderDetails?.status] || orderDetails?.status}</p>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Price </h6>
                    <p>{orderDetails?.price}</p>
                  </div>
                </Col>


                {
                  <div className="setting-area">
                    <Row className="justify-content-center">
                      { orderDetails.buyerId?._id && userDetail('Buyer', orderDetails.buyerId) }
                      { orderDetails.sellerId?._id && userDetail('Seller', orderDetails.sellerId) }
                    </Row>
                  </div>
                }

                {orderDetails?.validatorId?.fullName && (
                  <>
                    <div className="mb-2">
                      <h4 className="fw-bold text-primary">Validation Details</h4>
                    </div>
                    <Row className="pb-4 border border-2 border-primary rounded">
                      <Col md={6}>
                        <div className="referral-detail-body">
                          <h6>Validator Name</h6>
                          <p>{orderDetails?.validatorId?.fullName}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="referral-detail-body">
                          <h6>Validator Phone</h6>
                          <p>{orderDetails?.validatorId?.phone}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="referral-detail-body">
                          <h6>Price Validation</h6>
                          <p>{orderDetails?.priceValidation}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="referral-detail-body">
                          <h6>Validator Comments</h6>
                          <p>{orderDetails?.validatorComments}</p>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="unit-switchboard-area">
                          {orderDetails?.validationImages?.length > 0 && (
                            orderDetails.validationImages.map((media, index) => (
                              <div key={index}>
                                <div className="unit-switchboard-inner">
                                  <img src={config.resourceUrl.concat(media)} />
                                  <p>Validator Images</p>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </Row>
            </Row>
            {/* seller box */}
            { commission && 
            <Row>
              <Row className='mt-3 justify-content-end'>
                <Col md={4}>
                  <div className='outer-seeker'>
                    <div className='seeler-box'>
                      <h4>Validator Commission</h4>
                      <div className='under-text'>
                        <p>Net Payable</p>
                        <p className='dark-txt'>{ commission?.validatorCommission.toFixed(2) }</p>
                      </div>

                      <div className='under-text'>
                        <p>Payment Status</p>
                        <p className='dark-txt'>{ transactionStatus[commission?.validatorPaymentStatus || commission.validatorPaymentStatus] }</p>
                      </div>

                      <div className='under-text'>
                        <p>Payout Reference ID</p>
                        <p className='dark-txt'>{ commission.validatorCashoutId || 'NA' }</p>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className='outer-seeker'>
                    <div className='seeler-box'>
                      <h4>Seller</h4>
                      <div className='under-text'>
                        <p>Net Payable</p>
                        <p className='dark-txt'>
                          {Math.max(0, commission?.sellerPayable ?? 0).toFixed(2)}
                        </p>
                      </div>

                      <div className='under-text'>
                        <p>Payment Status</p>
                        <p className='dark-txt'>{ transactionStatus[commission.sellerPaymentStatus || commission.sellerPaymentStatus] }</p>
                      </div>

                      <div className='under-text'>
                        <p>Payout Reference ID</p>
                        <p className='dark-txt'>{ commission.sellerCashoutId || 'NA' }</p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className='justify-content-end mb-4'>
                <Col md={4} className='mb-4'>
                  <div className='under-text'>
                    <p>Product Price</p>
                    <p className='dark-txt'>{ commission?.grossAmount?.toFixed(2)}</p>
                  </div>
                  <div className='under-text'>
                    <p>Bid Amount</p>
                    <p className='dark-txt'>{ (commission?.validatorPayable + commission?.adminCommission + commission?.sellerPayable).toFixed(2)}</p>
                  </div>
                  <div className='under-text'>
                    <p>Validator Earning</p>
                    <p className='dark-txt'>{ commission?.validatorPayable.toFixed(2)}</p>
                  </div>
                  <div className='under-text'>
                    <p>Admin Earning:</p>
                    <p className='dark-txt'>{ commission?.adminCommission.toFixed(2)}</p>
                  </div>
                  <div className='under-text'>
                    <p>Seller Earning</p>
                      <p className='dark-txt'>
                        {Math.max(0, commission?.sellerPayable ?? 0).toFixed(2)}
                      </p>
                  </div>
                </Col>
              </Row>
            </Row>
            }
          </div>

        </Container>
      </div>

    </>
  )
};